// @ts-nocheck
// Product hero gallery slider, built on the project's Embla carousel.

(function () {
  function initProductGallery(root) {
    const viewport = root.querySelector('[data-gallery-viewport]');
    if (!viewport || !window.EmblaCarousel) return;

    const embla = EmblaCarousel(viewport, { loop: true, align: 'center' });

    // Embla's looped layout can settle one slide-width off on first paint, leaving
    // the first slide shifted and the next one peeking. A reInit recomputes the
    // start position — run it now and again once everything has loaded.
    embla.reInit();
    if (document.readyState !== 'complete') {
      window.addEventListener('load', () => embla.reInit(), { once: true });
    }

    const thumbs = Array.from(root.querySelectorAll('[data-gallery-thumb]'));

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => embla.scrollTo(index));
    });

    const setActive = () => {
      const selected = embla.selectedScrollSnap();
      thumbs.forEach((thumb, index) => {
        thumb.classList.toggle('opacity-100', index === selected);
        thumb.classList.toggle('opacity-40', index !== selected);
      });
    };

    embla.on('select', setActive);
    embla.on('reInit', setActive);
    setActive();
  }

  function initAll(scope = document) {
    scope.querySelectorAll('[data-product-gallery]').forEach(initProductGallery);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
